import React, { useState, useEffect, forwardRef } from 'react';
import { TextInput } from 'evergreen-ui';

const DebouncedInput = forwardRef(
  ({ value: initialValue, onChange, debounce = 500, ...props }, ref) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    useEffect(() => {
      const timeout = setTimeout(() => {
        onChange(value);
      }, debounce);

      return () => clearTimeout(timeout);
    }, [value, debounce, onChange]);

    return (
      <TextInput {...props} ref={ref} value={value} onChange={(e) => setValue(e.target.value)} />
    );
  }
);

DebouncedInput.displayName = 'DebouncedInput';

export default DebouncedInput;
